import { FilterDefinition } from 'src/app/paginated-table/filter-panel/filter-panel.component';

const USER_STATES = [
  { label: $localize`:filters|state values:Active`, value: 'active' },
  { label: $localize`:filters|state values:Fledgling`, value: 'fledgling' },
  { label: $localize`:filters|state values:Suspended`, value: 'suspended' },
]

export const FILTER_DEFINITIONS: FilterDefinition[] = [
  {
    label: $localize`:filters|Filter name:First Name`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'firstname' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'firstname' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Last Name`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'lastname' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'lastname' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Email`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'email' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'email' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Login`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'login' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'login' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Status`,
    operators: [
      { label: $localize`:filters|Operator name:is`, inputType: 'multiselect', operator: 'withStates', possibleValues: USER_STATES },
      { label: $localize`:filters|Operator name:is not`, inputType: 'multiselect', operator: 'withoutStates', possibleValues: USER_STATES }
    ]
  },
  {
    label: $localize`:filters|Filter name:Company`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'company' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'company' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Street`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'street' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'street' }
    ]
  },
  {
    label: $localize`:filters|Filter name:ZIP`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'zip' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'zip' }
    ]
  },
  {
    label: $localize`:filters|Filter name:City`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'city' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'city' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Country`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'country' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'country' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Fax`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'fax' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'fax' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Phone`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'phone' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'phone' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Cell Phone`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'cell_phone' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'cell_phone' }
    ]
  },
]
